/** @format */
/** @format */

import React, { FC, useEffect, useState } from 'react'
import {
  _$,
  Button,
  Dialog,
  Icon,
  Message,
  Switch,
  Pagination,
  Table,
  TableColumn
} from '@king-design/react'
import styled from 'styled-components'
import { PageProps, initPage } from 'src/utils/interface'
import { MonitorSearch } from 'src/components'
import { useAsyncFn } from 'react-use'
import {
  getPrometheusRecordList,
  updatePrometheusRecordState,
  deletePrometheusRecord
} from 'src/api/ApiPromethuesInstance'
import RecordEditDrawer from './EditDrawer'

interface SearchProps extends PageProps {
  Name: string
}

const initSearch: SearchProps = {
  Name: '',
  ...initPage
}
interface PrometheusInstanceRecordProps {
  className?: string
  tab: string
  instanceID: string
}
const InstanceRecord: FC<PrometheusInstanceRecordProps> = ({ className, tab, instanceID }) => {
  const [search, setSearch] = useState<SearchProps>(initSearch)
  const [editVisible, setEditVisible] = useState<boolean>(false)
  const [editId, setEditId] = useState<number>()

  useEffect(() => {
    if (tab === 'record') {
      ruleFetch()
    }
  }, [tab, search])

  const [{ value: rules }, ruleFetch] = useAsyncFn(
    async (values?) => {
      const params = {
        ...search,
        ...values
      }
      const result = await getPrometheusRecordList(params)
      return {
        data: result?.Groups || [],
        total: result?.Count || 0
      }
    },
    [search]
  )

  // 更新规则状态
  const [, updateStateFetch] = useAsyncFn(async params => {
    const result = await updatePrometheusRecordState(params)
    if (result?.code === 'Success') {
      Message.success(_$('更新成功'))
      ruleFetch()
    }
  }, [])

  // 删除规则
  const [, deleteFetch] = useAsyncFn(async ID => {
    const result = await deletePrometheusRecord(ID)
    if (result?.code === 'Success') {
      Message.success(_$('删除成功'))
      ruleFetch()
    }
  }, [])

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            setEditId(undefined)
            setEditVisible(true)
          }}
        >
          <Icon className="ion-plus-round" />
          {_$('新建预聚合')}
        </Button>
      </div>
      <div className="search_row">
        <div className="search_item">
          <p className="search_item_label">{_$('预聚合规则名称')}</p>
          <MonitorSearch
            placeholder={_$('请输入预聚合规则名称，支持模糊搜索')}
            onChange={value => {
              setSearch({
                ...search,
                Page: 1,
                Name: value
              })
            }}
          />
        </div>
      </div>
      <Table data={rules?.data || []} rowKey={data => data.ID} checkType="none" animation={false}>
        <TableColumn key="Name" title={_$('预聚合规则名称')} />
        <TableColumn key="RecordCount" title={_$('规则组个数')} />
        <TableColumn
          key="Status"
          title={_$('规则状态')}
          slotTemplate={([{ ID, Status, Name }]) => {
            return (
              <Switch
                on={_$('开')}
                off={_$('关')}
                width={80}
                value={Status === 1 ? true : false}
                beforeChange={async from => {
                  if (from) {
                    const result = await Dialog.confirm({
                      content: _$('是否确认停用【{name}】的预聚合规则？', { name: Name }),
                      okText: _$('确认停用')
                    }).then(
                      res => {
                        return true
                      },
                      err => {
                        return false
                      }
                    )
                    return result
                  } else {
                    return true
                  }
                }}
                onChangeValue={value => {
                  updateStateFetch({ ID, Status: value ? 1 : 0 })
                }}
              />
            )
          }}
        />
        <TableColumn
          key="operate"
          title={_$('操作')}
          width="150"
          slotTemplate={([record]) => {
            return (
              <div className="ksc-space">
                <a
                  onClick={() => {
                    setEditId(record.ID)
                    setEditVisible(true)
                  }}
                >
                  {_$('编辑')}
                </a>
                <a
                  onClick={() => {
                    let dialog: Dialog
                    Dialog.confirm({
                      content: _$('是否确认删除【{name}】的预聚合规则？', {
                        name: record?.Name
                      }),
                      ref: _dialog => (dialog = _dialog),
                      okText: _$('确认删除'),
                      ok: async () => {
                        dialog.showLoading()
                        await deleteFetch(record?.ID)
                        dialog.close()
                      }
                    })
                  }}
                >
                  {_$('删除')}
                </a>
              </div>
            )
          }}
        ></TableColumn>
      </Table>
      <Pagination
        value={search.Page}
        limit={search.PageSize}
        total={rules?.total || 0}
        size="small"
        onChangeValue={value => {
          setSearch(state => {
            return {
              ...state,
              Page: value
            }
          })
        }}
        onChangeLimit={limit => {
          setSearch({
            ...search,
            PageSize: limit
          })
        }}
      />
      <RecordEditDrawer
        visible={editVisible}
        onClose={update => {
          setEditVisible(false)
          if (update) {
            ruleFetch()
          }
        }}
        instanceID={instanceID}
        ID={editId}
      />
    </div>
  )
}

export default styled(InstanceRecord)`
  margin-top: 16px;
  .search_row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 16px;
    .search_item {
      display: flex;
      align-items: center;
      margin: 0 16px 16px 0;
      .search_item_label {
        margin: 0px 8px 0 0;
      }
    }
  }
  .k-pagination {
    margin-top: 16px;
    text-align: center;
  }
`
